import { isEqualObject } from '@/shared/compare'
import { deliveryIsFree } from '@/shared/delivery'
import { cloneObject } from '@/shared/clone'

export function addProduct (state, product) {
  const productInCart = getProductInCart(state, product)
  if (!productInCart) {
    state.cart.push(product)
    return
  }

  productInCart.quantity_in_stock = product.quantity_in_stock
  productInCart.variant = product.variant

  const newQuantity = productInCart.quantity + product.quantity
  const quantityInStock = getProductQuantityInStock(product)

  productInCart.quantity = Math.min(newQuantity, quantityInStock)
}

function getProductInCart (state, product) {
  const productInCart = state.cart.find(element => element.product_id === product.product_id)
  if (!productInCart) {
    return null
  }

  const variant = product.variant
  const variantInCart = productInCart.variant
  if (!!variant && !!variantInCart && variant.name !== variantInCart.name) {
    return null
  }

  if (!isEqualObject(product.formula, productInCart.formula)) {
    return null
  }

  return productInCart
}

function getProductQuantityInStock (product) {
  if (!!product.variation_theme && !!product.variant) {
    return product.variant.quantity_in_stock
  }

  return product.quantity_in_stock
}

export function removeProduct (state, index) {
  state.cart.splice(index, 1)
}

export function changeQuantity (state, { index, quantity }) {
  const product = state.cart[index]
  product.quantity = quantity
}

export function cleanShoppingCart (state) {
  state.cart = []
}

export function setCart (state, cart) {
  state.cart = cart
}

export function setDeliveryAddress (state, deliveryAddress) {
  state.deliveryAddress = deliveryAddress
}

export function setDeliveryType (state, deliveryType) {
  state.deliveryType = deliveryType
}

export function updateDeliveryTypeByCost (state, { deliveryTypes, totalCost }) {
  const deliveryType = state.deliveryType
  if (!deliveryType) {
    return
  }

  const delivery = cloneObject(deliveryTypes.find((delivery) => delivery.delivery_type === deliveryType.delivery_type && delivery.delivery_days === deliveryType.delivery_days))
  if (!delivery) {
    state.deliveryType = null
    return
  }

  deliveryType.cost = delivery.cost

  if (deliveryIsFree(deliveryType, totalCost)) {
    deliveryType.cost = 0
  }
}

export function setUser (state, user) {
  state.user = user
}
